import { render, staticRenderFns } from "./ManageCollectionItem.vue?vue&type=template&id=322ab49f&scoped=true&"
import script from "./ManageCollectionItem.vue?vue&type=script&lang=js&"
export * from "./ManageCollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageCollectionItem.vue?vue&type=style&index=0&id=322ab49f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ab49f",
  null
  
)

export default component.exports